import {basePathApi} from './basePathApi';
export const baseUrl =  basePathApi+'api/'
// export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000/api/' : basePathApi+'api/'
// export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://gtv_rewrite.test/api/' : basePathApi+'api/'
// export const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api/' : 'http://localhost:8000/api/'
